import apiClient from './apiClient';
import {ResponseDto} from "./ResponseDto";

export interface DashboardData {
    totalCoordinator: number;
    accumulatedReward: number;
    totalJobPosting: number;
    noticeContent: string;
    noticeCode: string;
    csCenterNumber: string;
}

export const getDashboard = () =>
    apiClient.get<ResponseDto<DashboardData>>("/api/front/dashboard/getDashboard");
